import { Link } from "react-router-dom"

import './helpbg.css'

export default function Helpbg() {

  return (
    <div className="help" >
      <br />
      <h2>Help Menu Before Login</h2>
      <br />
      <p>This website is a collection of your jokes and are rated.  
        You can input your jokes and rate any joke.  Please do 
        use profanity and keep it clean.  
      </p>
      <p>Login in with an email and your chosen password and have fun.
      </p>
      <br />
      <br />
      <Link className="btnYes" to="/login">Login</Link>

    </div>
  )
}